import api from './client';

export const getQuotes      = (projectId) => api.get('/quotes', { params: { project: projectId } });
export const getQuote       = (id) => api.get(`/quotes/${id}`);
export const createQuote    = (data) => api.post('/quotes', data);
export const updateQuote    = (id, data) => api.put(`/quotes/${id}`, data);
export const deleteQuote    = (id) => api.delete(`/quotes/${id}`);
export const getQuotePrices = () => api.get('/quotes/prices');
export const parseSepFile   = (file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/quotes/parse-sep', form);
};
